import styled from 'styled-components';

export const Grid = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 50000;
    box-sizing: border-box;
    pointer-events: none;
    display: flex;
    justify-content: space-between;
    > div {
        width: 11.8%;
        height: 100%;
        border-style: solid;
        border-width: 1px;
        border-color: rgba(255, 0, 0, 0.6);
        box-sizing: border-box;
    }
`;

export const Frame = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 2.15vw;
    z-index: 50000;
    box-sizing: border-box;
    pointer-events: none;
    > div {
        width: 100%;
        height: 100%;
        border-style: solid;
        border-width: 1px;
        border-color: rgba(255, 0, 0, 0.6);
        box-sizing: border-box;
    }
`;